import styles from "./RoleProvisioning.module.css";

/**
 * What the tool does, in two sentences: the insert rule for existing users and
 * what a "Will create" row means. Always visible above the upload step.
 */
export function ToolNotice() {
  return (
    <div className={styles.card}>
      <p className={styles.notice}>
        Grants the selected account-services roles to every email in the file. A role is added only
        where the user does not already hold it in their organisation; users who already have the
        role, or who are account owners, are skipped.
      </p>
      <p className={styles.notice}>
        <strong>Will create</strong> rows are emails with no Account Services user yet. They are
        matched against Address Book contacts by email; when the contact has an active role in
        exactly one firm with an active organisation, the account can be created and added to that
        organisation with the selected roles. Created users receive <strong>no email</strong> and
        log in with a one-time code.
      </p>
      <p className={styles.notice}>
        <strong>Account Owner</strong> can be granted on its own (never combined with other roles)
        and never creates accounts: emails without an existing user and membership are skipped.
      </p>
    </div>
  );
}
